import { Component, Input } from '@angular/core'
import { ComponentWithCopy } from '../../intefaces/interfaces'
import { NgClass } from '@angular/common'
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large'
import { BodyLarge } from '../../components/typography/body-large/body-large'
import { AnimateOnScroll } from 'primeng/animateonscroll'
import { Link } from '../../components/link/link'

@Component({
	selector: 'app-centered-3-by-3-grid',
	imports: [NgClass, HeadlineLarge, BodyLarge, AnimateOnScroll, Link],
	templateUrl: './centered-3-by-3-grid.html',
	styleUrl: './centered-3-by-3-grid.css',
})
export class Centered3By3Grid {
	@Input() content!: ComponentWithCopy

}
